<template>
    <div id="permissions">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <permissions-toolbar></permissions-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <permissions-manager :permission="permission" @setLoader="setLoader"
                        @setNotification="setNotification">
                    </permissions-manager>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import auth from '../../js/auth';
import PermissionsManager from '../../components/Admin/Permissions/Manager';
import PermissionsToolbar from '../../components/Admin/Permissions/Toolbar';

export default {
    name: 'permissions',
    components: {
        PermissionsManager,
        PermissionsToolbar
    },
    data() {
        return {
            loader: true,
            permission: {},
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getPermission() {
            this.permission = auth.getPermission("adminpermissions");
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.getPermission();
    }
}
</script>